import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Loading from "../Modals/Loading";
import newsService from "../Services/newsService";
import moment from 'moment';
import toast from 'react-hot-toast';
import Swal from 'sweetalert2';
import DeleteModal from "../Components/DeleteModal";

const News = () => {
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [deleting, setDeleting] = useState(false);
  const [deleteID, setDeleteID] = useState();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [trigger, setTrigger] = useState(false)

  useEffect(() => {
    const getNews = async () => {
      try {
        setLoading(true);
        const response = await newsService.fetchAllNews();
        setNews(response.post); // Assuming your response data has 'post'
        setLoading(false);
      } catch (error) {
        setLoading(false);
        toast.error('Error fetching news');
      }
    };
    getNews();
  }, []);

  const formatDate = (dateStr) => {
    const date = new Date(dateStr);
    return date.toLocaleDateString("en-CA"); // en-CA formats as YYYY-MM-DD
  };

  // const handleDelete = async (id) => {
  //   if (window.confirm("Are you sure you want to delete this news item?")) {
  //     try {
  //       await newsService.delete(id);
  //       toast.success('News deleted successfully');
  //       // Update the state to remove the deleted post
  //       setNews((prevNews) => prevNews.filter(item => item.id !== id));
  //     } catch (error) {
  //       toast.error('Error deleting news');
  //     }
  //   }
  // };
  const initiateDelete = (id) => {
    setOpen(!open);
    setDeleteID(id);
  };
  const handleDelete = () => {
    setDeleting(true);
    newsService.delete(deleteID).then((res) => {
      setDeleting(false);
      setTrigger(!trigger)
    });
  };

  return (
    <div className="mx-16 my-2">
    <DeleteModal
        open={open}
        setOpen={setOpen}
        deleteFunction={handleDelete}
        deleting={deleting}
      />
      <div className='flex justify-end'>
        <button
          onClick={() => { navigate('/news/add') }}
          className="button-primary"
        >
          Add News / Posts
        </button>
      </div>

      {loading ? (
        <div>
          <Loading />
        </div>
      ) :
          news && news.length ? (
            <div className="table-div">
            <table className="rounded-lg overflow-hidden">
              <thead className="bg-primary">
                <tr className="uppercase w-full text-white text-center">
                  <th className="rounded-tl-lg py-4 w-[1%]">
                    Title
                  </th>
                  <th className="py-4 w-[4%]">
                    Description
                  </th>
                  <th className="py-4 w-[1%]">
                    Date
                  </th>
                  <th className="rounded-tr-lg py-4 w-[1%]">
                    Delete
                  </th>
                </tr>
              </thead>
              <tbody>
                {news?.map((value, index) => (
                  <tr key={index} className="bg-accent border-b border-gray-200 text-center">
                    <td className="py-4 w-[1%] font-bold">
                      {value.title}
                    </td>
                    <td className="py-4 w-[4%]">
                      {value.description}
                    </td>
                    <td className="py-4 w-[1%]">
                      {formatDate(value.date)}
                    </td>
                    <td className="py-4 w-[1%]">

                      <button
                        onClick={() => initiateDelete(value.id)}
                        className="px-1 rounded-md text-primary hover:text-red-600"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke-width="2"
                          stroke="red"
                          class="size-4"
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            d="m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0"
                          />
                        </svg>
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          ) : (
            <div className="mt-20">
              <h1 className="font-bold text-2xl text-gray-700 text-center">No Data Found</h1>
            </div>
          )}
    </div>
  );
};

export default News;

